import React, { FC } from 'react'
import { Field, useFormikContext } from 'formik'
import {
  maxLSAmountLimit,
  maxSBPAmountLimit,
  minAmountLimit,
  PaymentFormValues,
  PaymentMethod,
} from '@entities/payment'
import { sumGtm } from '@shared/lib/gtm'
import { OldMoneyInputField } from '@shared/ui/organisms'
import { Payee } from '@root/api/ump-catalog-manager'
import { useCyberStore } from '@entities/tsp'

interface SteamAmountFieldProps {
  activeService: Payee
}

const SteamUserAmountField: FC<SteamAmountFieldProps> = ({ activeService }) => {
  const { paymentMethod } = useCyberStore()
  const { values, validateForm, handleBlur } = useFormikContext<PaymentFormValues>()

  const min = minAmountLimit
  const max = paymentMethod === PaymentMethod.SBP ? maxSBPAmountLimit : maxLSAmountLimit

  return (
    <Field
      isClearable
      autoComplete="off"
      size="md"
      maxLength={8}
      decimalLimit={2}
      label="Сумма пополнения, в рублях"
      placeholder={`От ${min} ₽`}
      hint={`Максимальная сумма ${max} ₽`}
      onBlur={async (e: React.FocusEvent<HTMLInputElement>) => {
        const validationErrors = await validateForm()

        if (!validationErrors?.price) {
          sumGtm(activeService?.providerName, values.price)
        }
        handleBlur(e)
      }}
      name="price"
      className="field-input"
      component={OldMoneyInputField}
    />
  )
}

export default SteamUserAmountField
